<template>

    <div v-if="giveaway.enabled">
        <div @click="onShowGiveawayPopupClick" class="giveawayIcon__wrapper">
            <img src="../../assets/icons/ic_gift_giveaway.svg">
        </div>
        <div @click="onShowGiveawayPopupClick" class="giveawayWrapper"
             v-if="giveaway.enabled && !giveaway.participates">
            <div class="giveawayConfetti__wrapper">
                <img src="../../assets/icons/confetti.svg">
            </div>

            <div class="giveawayTitle">{{translate('giveawayBottom_title')}}</div>
        </div>
        <div @click="onShowGiveawayPopupClick" class="giveawayWrapper__finish"
             v-if="giveaway.enabled && giveaway.participates">
            <div class="giveawayConfetti__wrapper">
                <img src="../../assets/icons/confetti.svg">
            </div>
            <div class="giveawayTitle">{{translate('giveawayBottomFinish_title')}}</div>
        </div>
    </div>

</template>

<script>
    import {mapGetters, mapState} from 'vuex';

    export default {
        name: 'giveawayBottomBlock',

        data() {
            return {
                langShow: false,
                langSelect: this.$ml.current,
            }
        },

        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
        },

        mounted() {

        },

        computed: {
            ...mapState({
                userInfo: state => state.auth.userInfo
            }),
            ...mapGetters({
                giveaway: 'rate/getGiveaway',
            }),
        },
        methods: {
            onShowGiveawayPopupClick() {
                this.settings.openGiveawayModal()
            },

        },

    }
</script>

<style scoped>


    .giveawayIcon__wrapper {
        position: absolute;
        bottom: 70px;
        left: 48%;
        height: 56px;
        width: 56px;
        background-color: #FFBF00;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.24);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99999;
    }

    .giveawayIcon__wrapper:hover {
        cursor: pointer;
    }

    .giveawayWrapper {
        height: 98px;
        border-radius: 4px 4px 0 0;
        background-color: #3F405C !important;
        width: 500px;
        box-shadow: 0 -2px 12px 0 rgba(5, 42, 114, 0.25);
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        z-index: 9999;
        overflow: hidden;
        margin-top: 45px;
    }

    .giveawayWrapper:hover {
        cursor: pointer;
    }

    .giveawayWrapper__finish {
        height: 93px;
        border-radius: 4px 4px 0 0;
        background-color: #36BC00 !important;
        width: 500px;
        box-shadow: 0 -2px 12px 0 rgba(5, 42, 114, 0.25);
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        overflow: hidden;
        margin-top: 45px;
    }

    .giveawayWrapper__finish:hover {
        cursor: pointer;
    }

    .giveawayConfetti__wrapper {
        position: absolute;
        top: -88px;
        width: 100%;
    }

    .giveawayConfetti__wrapper img {
        width: 100%;
    }

    .giveawayTitle {
        color: #FFFFFF;
        font-family: Montserrat;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0.57px;
        line-height: 20px;
        text-transform: uppercase;
        position: relative;
        text-align: center;
        padding-left: 15px;
        padding-right: 15px;
    }
    @media screen and (max-width: 1025px) {

    }
    @media screen and (max-width: 768px ) {
        .giveawayIcon__wrapper {
            left: 46%;
            bottom: 70px;
        }
    }
    @media screen and (max-width: 426px ) {
        .giveawayWrapper__finish {
            width: 100%;
        }
        .giveawayWrapper {
            width: 100%;
        }
        .giveawayIcon__wrapper {
            left: 43%;
            bottom: 75px;
        }
    }
    @media screen and (max-width: 376px) {
        .giveawayTitle {
            text-align: center;
            padding-left: 15px;
            padding-right: 15px;
        }
        .giveawayIcon__wrapper {
            left: 43%;
            bottom: 82px;
        }
    }

    @media screen and (max-width: 321px) {
        .giveawayIcon__wrapper {
            bottom: 82px;
        }
    }


</style>
